import { gql } from '@apollo/client';

const engine = {
  ENGINE: gql`
    fragment Engine on Engine {
      code
      attributes {
        shortname
        shortdescription
        longdescription
        fuelType
        fuelLabel
        powertrain
        capacity
        transmissionLabel
      }
    }
  `,
};

export default engine;
